import { isEmbedded } from '@/vuex/modules/embeddable/embeddable.utils'

const UNKNOWN_HOST = 'unknown'

const hostnameOf = (urlLike) => {
  try {
    return new URL(urlLike).hostname || UNKNOWN_HOST
  } catch {
    return UNKNOWN_HOST
  }
}

/**
 * Describes which site embeds the app, for analytics.
 * Returns null when not framed, otherwise hostnames only (never path or query):
 * embed_host is the outermost ancestor, embed_parent the direct parent.
 */
export const getEmbedHostProps = (
  ancestorOrigins = window.location.ancestorOrigins,
  referrer = document.referrer,
) => {
  if (!isEmbedded()) return null

  const origins = Array.from(ancestorOrigins || [])
  if (origins.length) {
    return {
      embed_host: hostnameOf(origins[origins.length - 1]),
      embed_parent: hostnameOf(origins[0]),
    }
  }

  const referrerHost = hostnameOf(referrer)
  return { embed_host: referrerHost, embed_parent: referrerHost }
}
